// longitude = d'est en ouest
// latitude = du nord au sud

const placeCardTemplate = document.getElementById('mm-map-place-template');
const placesContainer = document.getElementById('mm-map-places');
const placesJSONEls = document.querySelectorAll('#mm-places-json .metafield-json');
const mapboxTokenInput = document.getElementById('mm-mapbox-token');
const geocoderWrapper = document.querySelector('.mm-places-wrapper #mm-map-geocoder');

const PLACE_SELECTED_CLASS = 'selected';
const MARKER_DEFAULT_COLOR = '#3FB1CE';
const MARKER_SELECTED_COLOR = '#FF0000';

mapboxgl.accessToken = mapboxTokenInput.value;
const places = [];

placesJSONEls.forEach((placesJSONEl) => {
  JSON.parse(placesJSONEl.innerText).map((placeData) => {
    places.push({
      name: placeData.name,
      address: placeData.address,
      coordinates: [placeData.Longitude, placeData.Latitude],
    });
  });
});

function mmInsertPlaceCard(place) {
  const card = placeCardTemplate.content.cloneNode(true).firstElementChild;
  const nameEl = card.querySelector('[data-place-name]');
  nameEl.textContent = place.name;
  const addressEl = card.querySelector('[data-place-address]');
  addressEl.textContent = place.address;
  card.dataset.placeCoordinates = JSON.stringify(place.coordinates);

  placesContainer.appendChild(card);
}

function mmDisplayVisibleMarkers(map) {
  // const { _ne: NorthEast, _sw: SouthWest } = map.getBounds();
  // const maxNorth = NorthEast.lat;
  // const maxEast = NorthEast.lng;
  // const maxSouth = SouthWest.lat;
  // const maxWest = SouthWest.lng;
  // same with destructuring:
  const {
    _ne: { lng: maxEast, lat: maxNorth },
    _sw: { lng: maxWest, lat: maxSouth },
  } = map.getBounds();

  const visiblePlaces = places.forEach((place) => {
    // const lng = places.coordinates.lng;
    // const lat = places.coordinates.lat;
    const [lng, lat] = place.coordinates; // [-1.557900, 47.214370]

    const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;
    if (visible) {
      mmInsertPlaceCard(place);
    }
  });
}

function mmFlyToPlaceByCoordinates(coordinates) {
  const map = window.mmMap;
  map.flyTo({ center: coordinates, zoom: 15 }, { placeCoordinatesToSelect: coordinates });
}

function mmSelectPlaceByCoordinates(coordinates) {
  Array.from(placesContainer.children).forEach((placeCard) => {
    placeCard.classList.remove(PLACE_SELECTED_CLASS);

    const [cardLng, cardLat] = JSON.parse(placeCard.dataset.placeCoordinates);
    const [lng, lat] = coordinates;
    if (cardLng === lng && cardLat === lat) {
      placeCard.classList.add(PLACE_SELECTED_CLASS);
    }
  });

  mmHighLightPlaceMarkerByCoordinates(coordinates);
}

function mmHighLightPlaceMarkerByCoordinates(coordinates) {
  const [lng, lat] = coordinates;
  const markers = document.querySelectorAll('#mm-map [data-marker-place-coordinates]');

  markers.forEach((marker) => {
    const [markerLng, markerLat] = JSON.parse(marker.dataset.markerPlaceCoordinates);
    const markerPath = marker.querySelector('path');

    if (markerLng === lng && markerLat === lat) {
      markerPath.setAttribute('fill', MARKER_SELECTED_COLOR);
    } else {
      markerPath.setAttribute('fill', MARKER_DEFAULT_COLOR);
    }
  });
}

function mmInitMap() {
  const map = new mapboxgl.Map({
    container: 'mm-map', // container ID
    style: 'mapbox://styles/mapbox/streets-v12', // style URL
    center: [2.25, 46.45], // starting position [lng, lat]
    zoom: 5, // starting zoom
  });

  window.mmMap = map;

  // Add geocoded search in seperated div
  // https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-geocoder-outside-the-map/
  const geocoder = new MapboxGeocoder({
    mapboxgl: mapboxgl,
    accessToken: mapboxgl.accessToken,
    //countries: 'fr,gf,re' // comma separated list
  });
  geocoderWrapper.appendChild(geocoder.onAdd(map));

  //tracking 1/2
  geocoder.on('result', (e) => {
    //console.log('event: searched')
    gtag('event', 'pharma_searched');
  });

  // Add geolocate control to the map.
  map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      // When active the map will receive updates to the device's location as it changes.
      trackUserLocation: true,
      // Draw an arrow next to the location dot to indicate which direction the device is heading.
      showUserHeading: true,
    }),
  );

  places.forEach((place) => {
    const marker = new mapboxgl.Marker().setLngLat(place.coordinates).addTo(map);
    const markerElement = marker.getElement();

    markerElement.dataset.markerPlaceCoordinates = JSON.stringify(place.coordinates);

    markerElement.addEventListener('click', () => {
      mmFlyToPlaceByCoordinates(place.coordinates);
    });
  });

  map.on('moveend', (event) => {
    placesContainer.innerHTML = null;

    if (map.getZoom() > 5) {
      mmDisplayVisibleMarkers(map);
    }

    // if move was triggered by mmFlyToPlaceByCoordinates, highlight card in list
    if (event.placeCoordinatesToSelect) {
      mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
    }
  });

  placesContainer.addEventListener('click', (event) => {
    const target = event.target;
    const card = target.closest('.mm-map-place-card');
    const coordinates = JSON.parse(card.dataset.placeCoordinates);

    mmFlyToPlaceByCoordinates(coordinates);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    mmInitMap();
  } catch (e) {
    console.error('Error initializing map: ', e.message);
  }
});

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

waitForElm('.mapboxgl-ctrl-geolocate').then((elm) => {
  //console.log('elm', elm);
  elm.click();
});

//tracking 2/2

window.addEventListener('load', function () {
  const mapboxCtrlGeolocate = document.querySelector('.mapboxgl-ctrl-geolocate');
  if (mapboxCtrlGeolocate) {
    mapboxCtrlGeolocate.addEventListener('click', function () {
      gtag('event', 'localisation_clicked');
    });
  }
});

const pharma_cta = document.querySelector('.find_my_pharma_cta');
if (pharma_cta) {
  pharma_cta.addEventListener('click', function () {
    gtag('event', 'pharma_cta_clicked');
  });
}
